import React from 'react'
import './FormModal.scss'
import Form from '../Form/Form'
const FormModal = ({setShowModal, show}) => {
  return (
    <div className='formModal_block'>
      <Form setShowModal={setShowModal} show={show} endpoint={'add_deal_ckc'} service_name={''}/>
    </div>
  )
}

export default FormModal
